const onSwymLoadCallback = (swat) => {
  // Please make all SWYM-related API calls inside this function.
  // You can use the swat argument within this scope.

  // Define eventname
  let addToCart = 'sw:addedtocart';

  // Define the event listener function
  let addToCartListener = function (e) {
    var data = e.detail.d.productData;
    console.log("YAY! Added the product to cart", data);

    let itemArray;
    itemArray = [
			{
        id: data["id"],
        quantity: 0
			}
    ];

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        items: itemArray, sections: 'mini-cart,header'
      },
      success: function (response) {
        const reRenderShopifySections = (
          response,
          selector = '[data-rerender]'
          ) => {
          return Object.keys(response.sections).forEach((key) => {
            const updatedNodes = new DOMParser()
            .parseFromString(response.sections[key], 'text/html')
            .querySelectorAll(selector)
          
            document
            .querySelector(`[id^="shopify-section-"][id*="${key}"]`)
            .querySelectorAll(selector)
            .forEach((node, index) => {
              node.replaceWith(updatedNodes[index])
            })
          })
        }

        reRenderShopifySections(response)

        document.querySelector('hh-mini-cart').dispatchEvent(
          new CustomEvent('productAdded', {
            detail: {
              response,
            },
          })
        )
      },
      error: function (XMLHttpRequest, textStatus) {
        console.error(`Wishlist::addToCart - error`, textStatus);
        //The item is probably out of stock / unavailable in Shopify
        alert("Unable to add item to your cart");
      }
    });
  };

  // Add listener for the 'addedtocart' event to the Swym Event Layer
  swat.evtLayer.addEventListener(addToCart, addToCartListener);
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);
